/* eslint-disable complexity */
import { CSSProperties } from 'react';

import { ImageWrapper, ImageSpacer, ImageTag } from './styles';

interface ImageProps {
  className?: string;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  data: any;
  width?: string | number;
  height?: string | number;
  alt?: string;
  loading?: 'lazy' | 'eager';
  objectFit?: string;
  imgStyle?: CSSProperties;
}

const Image = ({
  data,
  width,
  height,
  alt = '',
  loading = 'lazy',
  objectFit = 'cover',
  imgStyle = {},
  ...props
}: ImageProps) => {
  const image = data?.asset?.localImage?.childImageSharp?.gatsbyImageData
    || data?.localImage?.childImageSharp?.gatsbyImageData
    || data?.childImageSharp?.gatsbyImageData
    || data?.gatsbyImageData
    || null;

  const altText = alt
    || data?.altText
    || data?.description
    || image?.altText
    || image?.description
    || '';

  if (!image && data?.asset?.localImage?.publicURL) {
    return (
      <ImageTag
        loading={loading}
        decoding="async"
        // @ts-ignore see https://github.com/facebook/react/issues/27233. Bugfix slated for React 19.
        fetchpriority={loading === 'eager' ? 'high' : 'auto'}
        src={data.asset.localImage.publicURL}
        width={width}
        height={height}
        alt={altText}
        style={imgStyle}
        $objectFit={objectFit}
        {...props}
      />
    );
  }

  return image && (
    <ImageWrapper {...props}>
      <ImageSpacer $width={image?.width} $height={image?.height} />
      <picture>
        {image?.images?.sources?.map(
          ({ ...source }) => <source key={source.srcSet} {...source} />,
        )}
        {image?.images?.fallback && (
          <ImageTag
            loading={loading}
            decoding="async"
            fetchpriority={loading === 'eager' ? 'high' : 'auto'}
            width={width || image?.width}
            height={height || image?.height}
            alt={altText}
            style={imgStyle}
            {...(image?.images?.fallback || {})}
            $objectFit={objectFit}
          />
        )}
      </picture>
    </ImageWrapper>
  );
};

export default Image;
